import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as myGlobal from 'global';
import { CookieService } from 'ngx-cookie-service';

@Injectable( {
    providedIn: 'root'
} )

export class AssessmentService {
    constructor( private http: HttpClient, private cookieService: CookieService ) {
    }

    getAssessmentContext() {
        return this.http.get( myGlobal.ASSESSMENT_MANAGEMENT + '/' + 'assessment_contexts' );
    }

    getAssessmentId( id ) {
        console.log( 'id', id );
        return this.http.get( myGlobal.ASSESSMENT_MANAGEMENT + '/' + 'assessment_contexts' + '/' + id );
    }

    deletePreviousAssmtScore( deleteString ) {
        return this.http.delete( myGlobal.Questionnaires + deleteString );
    }

}
